import { render, staticRenderFns } from "./Heads.vue?vue&type=template&id=007baf42&scoped=true&"
import script from "./Heads.vue?vue&type=script&lang=js&"
export * from "./Heads.vue?vue&type=script&lang=js&"
import style0 from "./Heads.vue?vue&type=style&index=0&id=007baf42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007baf42",
  null
  
)

export default component.exports